import type { ReactNode } from 'react'
import classNames from 'classnames'
import { HandPointingUpIcon } from '../icons/HandPointingUp'

type AlertColor = 'info' | 'warning' | 'danger' | 'success'

const colorStyles = {
  info: 'border-fixed-teal bg-fixed-light-teal',
  warning: 'border-fixed-accent-color bg-fixed-light-yellow',
  danger: 'border-core-error bg-[rgba(243,86,66,0.1)]',
  success: 'border-core-success bg-fixed-light-mint',
}

export function BreakoutAlert({
  children,
  className,
  variant,
  iconPosition = 'left',
  icon,
}: {
  children: ReactNode
  className?: string
  variant: AlertColor
  iconPosition?: 'left' | 'right'
  icon?: ReactNode
}) {
  const iconElement = icon ?? <HandPointingUpIcon />
  return (
    <div
      className={classNames(
        'flex items-center gap-2 rounded-lg border px-3 py-2',
        colorStyles[variant],
        className
      )}
    >
      {iconPosition === 'left' && iconElement}
      <div className="flex-1 text-body-medium">{children}</div>
      {iconPosition === 'right' && iconElement}
    </div>
  )
}
